import React from "react";
import "./department.css";
import Navbar from "../../navbar/Navbar";
import Footer  from "../../footer/Footer";
function Department() {
  return (
    <>
      <Navbar />
      <div className="department_container">
        <section>
        <div className="department_sub1">
          <h1>
            Our <span style={{ color: "rgb(119,94,209)" }}>Departments</span>
          </h1>
          <br />
          <div className="department_card_container">
            <Department_card
              name="VITS"
              url="https://allegiance-educare.in/storage/uploads/colleges/1686397822vits%201.JPG"
            />
            <Department_card
              name="VIMS"
              url="https://images.collegedunia.com/public/college_data/images/appImage/1489731909cover.jpg?h=260&w=360&mode=crop"
            />
            <Department_card
              name="VIMR"
              url="https://www.vitsdpr.ac.in/VIMR/img/clgpics/slider.jpg"
            />
            <Department_card
              name="INDORE"
              url="https://www.vitsdpr.ac.in/VIMR/img/clgpics/slider.jpg"
            />
            <Department_card
              name="SATNA"
              url="https://www.vitsdpr.ac.in/VIMR/img/clgpics/slider.jpg"
            />
            <Department_card
              name="RAIPUR"
              url="https://www.vitsdpr.ac.in/VIMR/img/clgpics/slider.jpg"
            />
          </div>
        </div>
        </section>
      </div>
      <Footer/>
    </>
  );
}
function Department_card(props) {
  return (
    <div>
      <div className="department_card">
        <h1>{props.name}</h1>
        <img src={props.url} /><br />
        <p>This is best college in the satna </p>
        <button className="btn">Know more</button>
        <div className="icon">
          <i className="fab fa-facebook"></i>
          <i class="fa-brands fa-x-twitter"></i>
          <i className="fab fa-instagram"></i>
          <i className="fab fa-whatsapp"></i>
        </div>
      </div>
    </div>
  );
}

export default Department;
